"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = require("../../common");
exports.default = {
    type: "object",
    properties: {
        action: {
            type: "string",
            title: "Select Action",
            default: "SCHEDULE_VISIT",
            oneOf: [
                {
                    const: "SCHEDULE_VISIT",
                    title: "Schedule Visit",
                },
                {
                    const: "CANCEL_VISIT",
                    title: "Cancel Visit",
                },
            ],
        },
        visitDate: {
            type: "number",
            format: "date",
            title: "Visit Date",
            disablePast: true,
        },
        futureAppointment: (0, common_1.makeAppointmentSchema)({
            disablePast: true,
            isRequired: true,
        }),
        notes: { type: "string", title: "Notes", maxLength: 3000 },
    },
    if: {
        properties: { action: { const: "SCHEDULE_VISIT" } },
    },
    then: {
        required: ["futureAppointment"],
    },
    else: {
        required: ["visitDate", "visitToCancel"],
    },
    required: ["action"],
};
